import {
  getFinancialArrangments as getFinancialArrangmentsApi,
  updateFinancialArrangments as updateFinancialArrangmentsApi,
  createClientSecrete as createClientSecreteApi,
  validateStripeAccount as validateStripeAccountApi,
  getSavedPaymentMethods as getSavedPaymentMethodsApi
} from './api'

let getFinancialArrangments = (params) => dispatch => {
  return getFinancialArrangmentsApi(params)
}

let updateFinancialArrangments = (data, params = {}) => dispatch => {
  return updateFinancialArrangmentsApi(data, params)
}

let createClientSecrete = (data) => dispatch => {
  return createClientSecreteApi(data)
}

let validateStripeAccount = (data) => dispatch => {
  return validateStripeAccountApi(data)
}

let getSavedPaymentMethods = (params = {}) => dispatch => {
  return getSavedPaymentMethodsApi(params)
}

export {
  getFinancialArrangments,
  updateFinancialArrangments,
  createClientSecrete,
  validateStripeAccount,
  getSavedPaymentMethods
}
